// * ========================================================================
// * Replace default selects by custom ones
// * ========================================================================

'use strict';

import $ from 'jquery';

var setSelectValue = function($textholder,value){
  $textholder.empty().append(value);
};

var createCustomSelects = (function() {

  function init(){
    var $ogselect = $('.js-custom-select');

    if($ogselect.find('option').length){
      $ogselect.each(function(){
        var $textholder = $('<span class="custom-select__text js-custom-select-textholder"></span>');
        var $wrapper = $('<div class="custom-select js-custom-select-wrapper"></div>');
        var $select = $('<div class="custom-select__dropdown js-custom-select-dropdown"></div>');

        if($(this).hasClass('form__field-select-custom-full-width')){
          $wrapper.addClass('custom-select-full-width');
        }

        $(this).wrap($wrapper).before($select,$textholder);
        $textholder.empty().append($(this).find('option')[0].innerHTML);

        $($(this)).on('change',function(){
          $textholder.empty().append($(this).find('option:selected').text());
          setSelectValue($(this).find('.js-custom-select-textholder'), $(this).find('option:selected').text());
        });

      });

      //Make sure custom selects have correct value shown on load
      $('.js-custom-select-wrapper').each(function(){
        setSelectValue($(this).find('.js-custom-select-textholder'), $(this).find('option:selected').text());
      });
    }
  }
  return {
    init: init
  }
})();

module.exports = createCustomSelects;
